var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_16499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4334 8.33334H37.5667C38.4804 8.33332 39.269 8.33329 39.9217 8.37782C40.6088 8.42471 41.2961 8.52784 41.9752 8.80909C43.5065 9.44342 44.7234 10.6601 45.3575 12.1916C45.6388 12.8706 45.7419 13.5579 45.789 14.245C45.8334 14.8977 45.8334 15.6862 45.8334 16.6V33.4C45.8334 34.3138 45.8334 35.1023 45.789 35.755C45.7419 36.4421 45.6388 37.1294 45.3575 37.8085C44.7234 39.3398 43.5065 40.5567 41.9752 41.1908C41.2961 41.4721 40.6088 41.5752 39.9217 41.6223C39.269 41.6667 38.4804 41.6667 37.5667 41.6667H12.4334C11.5195 41.6667 10.731 41.6667 10.0784 41.6223C9.39125 41.5752 8.70394 41.4721 8.02492 41.1908C6.4935 40.5567 5.27677 39.3398 4.64244 37.8085C4.36119 37.1294 4.25806 36.4421 4.21117 35.755C4.16665 35.1023 4.16667 34.3138 4.16669 33.4V16.6C4.16667 15.6862 4.16665 14.8977 4.21117 14.245C4.25806 13.5579 4.36119 12.8706 4.64244 12.1916C5.27677 10.6601 6.4935 9.44342 8.02492 8.80909C8.70394 8.52784 9.39125 8.42471 10.0784 8.37782C10.731 8.33329 11.5195 8.33332 12.4334 8.33334ZM8.99471 13.0787C9.7524 12.2128 11.0686 12.125 11.9345 12.8827L23.6281 23.1146C24.4136 23.8019 25.5865 23.8019 26.3719 23.1146L38.0656 12.8827C38.9315 12.125 40.2477 12.2128 41.0052 13.0787C41.7629 13.9446 41.6752 15.2608 40.8094 16.0184L29.1156 26.2504C26.7592 28.3123 23.2409 28.3123 20.8844 26.2504L9.19071 16.0184C8.32479 15.2608 8.23704 13.9446 8.99471 13.0787Z",
    fill: "#0A49A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_16499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBlue);
export default __webpack_public_path__ + "static/media/email-blue.bb9faa6545cc2f1f962b9867254c0702.svg";
export { ForwardRef as ReactComponent };